// extracted by mini-css-extract-plugin
export default {"slider_wrpr":"sideSlider_slider_wrpr__l0f+U"};